<style scoped>
	#Preview {
		width: 1000px;
		margin: 0 auto;
		padding-top: 30px;
		font-size: 16px;
	}

	#btm {
		width: 200px;
		height: 40px;
		background: #141651;
		color: #fff;
		text-align: center;
		line-height: 40px;
		margin: auto;
		cursor: pointer;
	}

	.main_tbl {
		width: 100%;
		margin-bottom: 30px;
	}

	.main_tbl tr {
		height: 52px;
		line-height: 52px;
		border: 1px #DDDDDD solid;
	}

	.left_td {
		text-align: right;
		padding-right: 10px;
		background-color: #EEEEEE;
		width: 300px;
	}

	.right_td {
    width:697px;
		padding-left: 10px;
    word-wrap: break-word;
	}
  .magic-radio + label:before, .magic-checkbox + label:before{
    top: 5px;
  }
  .magic-radio + label:after{
    top: 11px;
  }
  .magic-radio + label:before, .magic-checkbox + label:before{
    border:1px solid #f39800;
  }

</style>
<template>
	<div id="Preview">
		<table class="main_tbl">

			<tr>
				<td class="left_td">Presenting Type</td>
				<td class="right_td">{{ paper.paperForm }}</td>
			</tr>
			<tr>
				<td class="left_td">Topic</td>
				<td class="right_td">{{ paper.paperType }}</td>
			</tr>
			<tr>
				<td class="left_td">NO</td>
				<td class="right_td">{{ paper.paperNo }}</td>
			</tr>
			<tr>
				<td class="left_td">Title</td>
				<td class="right_td">{{ paper.paperTitle }}</td>
			</tr>
			<tr>
				<td class="left_td">Keyword</td>
				<td class="right_td">{{ paper.paperKeyword }}</td>
			</tr>
			<tr>
				<td class="left_td">Content</td>
				<td class="right_td">{{ paper.paperSummary }}
				</td>
			</tr>

			<tr v-for="(file, index)  in  files">
				<td class="left_td">Attachment {{index+1}}</td>
				<td class="right_td">
					<a v-bind:href="file.fileUrl" target="_blank">{{file.fileOrig}}</a>
				</td>

			</tr>
			<tr>
				<td class="left_td">Conflict of Interest Disclosure:</td>
				<td class="right_td" style="line-height: 30px;">
          <input class="magic-radio" type="radio" name="radio6" id="1" value="sect" v-model="single" />
          <label for="1">I declare that my presentation will be objective and free of commercial bias. </label>
					<!--<Radio v-model="single" style="font-size: 16px;">-->
						<!--</Radio>-->
					All the information regarding commercial products or services is based on scientific methods generally accepted by the medical community.
				</td>
			</tr>

		</table>

		<div id="btm" @click="next">Save and Next</div>
	</div>
</template>

<script>
	import Bus from '@/bus'
  import  'iview/src/styles/common/iconfont/fonts/ionicons.eot'
  import 'iview/src/styles/common/iconfont/fonts/ionicons.svg'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.ttf'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.woff'
	export default {
		data() {
				return {
					paperid: 0,
					paper: {},
					files: [],
					single: false
				}
			},
			mounted() {
				this.paperid=localStorage.getItem('paperId');
				//获取会议对应的正文投稿配置
				this.postHttp('/medapp/api/paper/getpapersinfo', {
					paperid: this.paperid
				}).then((result) => {
					let data = '';
					if(result.data.paper != null) {
						this.paper = result.data.paper;
						this.files = result.data.paper.files;
						return;
					}

				})
			},
			methods: {
				next() {
					if(!this.single) {
						this.$Notice.warning({
							title: 'Warnning',
							desc: 'Please complete the conflict of interest disclosure. '
						});
						return;
					}
						//获取会议对应的正文投稿配置
					this.postHttp('/medapp/api/paper/addorupdatepaper', {
						paperid: this.paperid,
						status: "1"
					}).then((result) => {
						let data = '';
						if(result.data.code == "0") {
							Bus.$emit('button', 4);
							this.$router.push('/home_en/2006/submit/Success');
							return;
						} else {
							this.$Message.info('Update status error.');
						}
					})

				}
			}

	}
</script>



// WEBPACK FOOTER //
// Preview.vue?1d8b0903